import { defineComponent as _defineComponent } from 'vue';
import { trans, transChoice } from 'laravel-vue-i18n';
import DetailValue from '../../../Components/DetailValue.vue';
import { formatISODate } from '../../../Services/Utils';
import { useMitt } from '../../../Plugins/mitt';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const emitter = useMitt();
        const openSoilDataDetails = () => emitter.emit('open-soil-data-details', props.data.soil_data);
        const openSymptomRecordDetails = () => emitter.emit('open-symptom-record-details', props.data.symptom_record);
        const __returned__ = { emitter, props, openSoilDataDetails, openSymptomRecordDetails, get trans() { return trans; }, get transChoice() { return transChoice; }, DetailValue, get formatISODate() { return formatISODate; }, get Column() { return Column; }, get DataTable() { return DataTable; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
